import {LibraryItem} from 'powtoon-commons/models/types'
import {ITEM_TYPES} from 'powtoon-document/consts'
import {SLIDE_WIDTH, SLIDE_HEIGHT} from 'powtoon-commons/models/consts'
import {Size} from './images'

interface ShrinkToFitInSlideType extends Size {
  itemType: string
}

const SCALE_CONTAINER_ITEM_TYPE_MAP = {
  [ITEM_TYPES.VIDEO]: 0.75,
  [ITEM_TYPES.ACTOR]: 0.75
}

export const fitItemToFrame = (
  {width: itemWidth, height: itemHeight}: LibraryItem,
  {width: frameWidth, height: frameHeight}: Size,
  fillFrameArea: boolean = false
): Size | undefined => {

  if (!itemWidth || !itemHeight) {
    return
  }

  const horizontalScaleCoefficient = frameWidth / itemWidth
  const verticalScaleCoefficient = frameHeight / itemHeight

  const scaleCoefficient = fillFrameArea ?
    Math.max(horizontalScaleCoefficient, verticalScaleCoefficient) :
    Math.min(horizontalScaleCoefficient, verticalScaleCoefficient)

  return {
    width: itemWidth * scaleCoefficient,
    height: itemHeight * scaleCoefficient
  }
}

export function shrinkToFitInSlide({width, height, itemType}: ShrinkToFitInSlideType): Size {
  const scaleContainer = SCALE_CONTAINER_ITEM_TYPE_MAP?.[itemType] || 1
  const containerWidth = SLIDE_WIDTH * scaleContainer
  const containerHeight = SLIDE_HEIGHT * scaleContainer

  if (width < containerWidth && height < containerHeight) {
    return {width, height}
  }

  const ratio = width / height
  const slideRatio = containerWidth / containerHeight

  return (ratio < slideRatio) ?
    {
      width: containerHeight * ratio,
      height: containerHeight
    } :
    {
      width: containerWidth,
      height: containerWidth / ratio
    }
}
